import React, { Component } from 'react';
import 'react-dropdown/style.css';
import { dismissAlert } from './redux/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './DismissAlert.scss';
import { BlueContainedButton } from '../../../../shared/button/blue-contained-button/BlueContainedButton';
import Select from 'react-select';
import PageHeaderWithBackButton from '../../../../shared/headers/PageHeaderWithBackButton';

class DismissAlert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: this.props.location.state.alert,
            dismissalReason:
                this.dismissalReasons.find(
                    reason =>
                        reason === props.location.state.alert.dismissalReason
                ) || this.dismissalReasons[0],
            note: this.props.location.state.alert.note || ''
        };
    }

    dismissalReasons = [
        {
            label: 'Case Resolved',
            value: 'CASE_RESOLVED'
        },
        {
            label: 'False Positive',
            value: 'FALSE_POSITIVE'
        }
    ];

    dismissReasonSelectStyles = {
        control: (provided, { isDisabled }) => ({
            ...provided,
            width: '200px',
            border: 'var(--normal-light-gray-border)',
            borderRadius: 'var(--rounded-border)',
            backgroundColor: 'white',
            opacity: isDisabled ? '0.6' : '1'
        })
    };

    label(labelText) {
        return <span className={'alert-label'}>{labelText}</span>;
    }

    handleTextAreaChange = event => {
        this.setState({ ...this.state, note: event.target.value });
    };

    handleDismissalReasonChange = dismissalReason =>
        this.setState({ ...this.state, dismissalReason });

    dismiss = () => {
        this.props.dismissAlert(
            this.state.alert.id,
            this.state.dismissalReason.value,
            this.state.note
        );
    };

    render() {
        const { id, dismissed } = this.state.alert;
        return (
            <span className="alerts-main-container container">
                <PageHeaderWithBackButton />

                <span className={'dismiss-alert-container'}>
                    <span className={'alert-row'}>
                        {this.label('ID:')}
                        <span className="player-id-profile">{id}</span>
                    </span>
                    <span className={'alert-row'}>
                        {this.label('Reason:')}
                        <Select
                            styles={this.dismissReasonSelectStyles}
                            isDisabled={dismissed}
                            options={this.dismissalReasons}
                            value={this.state.dismissalReason}
                            onChange={option =>
                                this.handleDismissalReasonChange(option)
                            }
                            isValidNewOption={() => false}
                        />
                    </span>
                    <span className={'alert-column'}>
                        {this.label('Note:')}
                        <textarea
                            placeholder={'Type a note for this alert...'}
                            onChange={this.handleTextAreaChange}
                            value={this.state.note}
                            disabled={dismissed}
                        />
                    </span>
                    {!dismissed && (
                        <span className={'dismiss-button'}>
                            <BlueContainedButton
                                text={'Dismiss'}
                                onClick={this.dismiss}
                            />
                        </span>
                    )}
                </span>
            </span>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dismissAlert: (alertId, reason, note) =>
        dispatch(dismissAlert({ alertId, reason, note }))
});

export default withRouter(connect(null, mapDispatchToProps)(DismissAlert));
